<div class="container-fluid">
  <ul class="nav app-nav" *ngIf="userIsLoggedIn">
    <li class="nav-item">
      <a
        class="nav-link"
        routerLink="/dashboard"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        Dashboard
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLink="/users" routerLinkActive="active">Users</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLink="/open-connections" routerLinkActive="active">Open Connections</a>
    </li>
    <li class="nav-item ms-auto">
      <button class="nav-link btn btn-link p-0 px-2" type="button" (click)="onLogout()">Logout</button>
    </li>
  </ul>
  <router-outlet></router-outlet>
  <simple-notifications [options]="options"></simple-notifications>
</div>